import Column from '@components/column'
import Row from '@components/row'
import Fields from '@components/fields'
import { Constant } from '@utils'
import { styleRow, styleInputWrapper } from './style'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Category } from '@apis'
import ChooseSpecializations from '@commons/specializations'
const DoctorStep2Form = ({ values, setFieldValue, errors }) => {
  const { data: departments } = useSelector((state: any) => state.departments)
  const fetchDepartments = async () => {
    await Category.list({
      state: 'departments',
      params: {
        type: 'Department',
      },
    }).catch(() => {})
  }

  useEffect(() => {
    if (!departments?.length) {
      fetchDepartments()
    }
  }, [])

  return (
    <Column rowGap={15}>
      <Fields.DropDown
        name="departments"
        titleAsKey="name"
        valueAsKey="id"
        options={departments}
        placeholder="Select Your Department"
        label="Department"
        hasSearch
      />
      <Fields.Input
        name="qualification"
        placeholder="Enter your qualification"
        label="Qualification"
      />
      <Row styleRow={styleRow} justifyContent="space-between">
        <Fields.Input
          type="number"
          placeholder="Years of experience"
          label="Years of Service"
          name="yos"
          styleWrapper={styleInputWrapper}
        />
        <Fields.Input
          type="number"
          placeholder="Consultation Fee"
          label="Consultation Fee"
          name="fees"
          styleWrapper={styleInputWrapper}
        />
      </Row>
      <Row colGap={20}>
        <Fields.ChooseButton
          items={Constant.genders}
          label="Gender"
          name="gender"
          valueAsKey="value"
          titleAsKey="name"
          multiple={false}
          styleButton="height:42px;"
        />
        <Fields.Input
          type="number"
          name="age"
          placeholder="Enter Age"
          label="Age"
        />
      </Row>
      <Fields.DropDown
        name="appointmentType"
        options={Constant.appointmentTypes}
        label="Select Appointment Type"
        placeholder="Appointment"
        titleAsKey="label"
        valueAsKey="value"
      />
      <ChooseSpecializations
        isError={errors?.specializations}
        selectedItems={values?.specializations}
        onChange={(item: any) => {
          const findIndex = values?.specializations?.findIndex(
            (selected: any) => selected?.id == item.id,
          )
          if (findIndex >= 0) {
            setFieldValue(
              'specializations',
              values?.specializations?.filter(
                (symptom) => symptom?.id != item?.id,
              ),
            )
          } else {
            setFieldValue('specializations', [...values?.specializations, item])
          }
        }}
      />
    </Column>
  )
}

export default DoctorStep2Form
